import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import { GoodsShelf } from './goods-shelf/goods-shelf'

const path = '/main/mall/mallShelf'

export const MALL_GOODS_SHELF = path + '/goodsShelf'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/goodsShelf'} component={GoodsShelf}></Route>
        </Switch>
    )
}
